// ** React Imports
import {Fragment} from 'react'

// ** Custom Components
import NavbarUser from './NavbarUser'
import {NavItem, NavLink} from "reactstrap"
import * as Icon from "react-feather"
import {useTranslation} from "react-i18next"
import {useSelector} from "react-redux"

const ThemeNavbar = props => {
    // ** Props
    const {skin, setSkin, setMenuVisibility} = props
    const {t} = useTranslation()
    const store = useSelector(state => state.auth)

    let userName = `${store?.userData?.firstName} ${store?.userData?.surname}`
    if (userName.length > 25) {
        userName = `${userName.slice(0, 23)}...`
    }

    return (
        <Fragment>
            <div className='bookmark-wrapper d-flex align-items-center'>
                <ul className='navbar-nav d-xl-none'>
                    <NavItem className='mobile-menu me-auto'>
                        <NavLink className='nav-menu-main menu-toggle hidden-xs is-active'
                                 onClick={() => setMenuVisibility(true)}>
                            <Icon.Menu className='ficon'/>
                        </NavLink>
                    </NavItem>
                </ul>
                <span
                    className='d-none d-sm-flex d-md-flex d-lg-flex d-xl-flex'>{t('navigation.logged_as')}:&nbsp;</span>
                <strong>{userName}</strong>
            </div>
            <NavbarUser skin={skin} setSkin={setSkin}/>
        </Fragment>
    )
}

export default ThemeNavbar
